
class DeliveryRoutesListCell extends MUITableViewCell
{
    private nameLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
    }

    set item(i:DeliveryRoute){
        this.nameLabel.text = i.name;
    }

}